exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*,body{margin:0;padding:0}body{-webkit-font-smoothing:antialiased;font-size:.8rem;font-family:Hiragino Sans GB,Microsoft Yahei,SimSun,Tahoma,Arial,Helvetica,STHeiti}.title{text-align:center;padding:.5rem;color:#31b29c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4ce56fda!./~/vue-loader/lib/selector.js?type=styles&index=0!./demo/app.vue
// module id = 119
// module chunks = 0